/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type DeleteGoogleDriveFileLinkInput = {
    id?: string | null | undefined;
    taskId?: string | null | undefined;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type deleteGoogleDriveFileLinkMutationVariables = {
    input: DeleteGoogleDriveFileLinkInput;
};
export type deleteGoogleDriveFileLinkMutationResponse = {
    readonly deleteGoogleDriveFileLink: {
        readonly deletedGoogleDriveFileId: string | null;
    } | null;
};
export type deleteGoogleDriveFileLinkMutation = {
    readonly response: deleteGoogleDriveFileLinkMutationResponse;
    readonly variables: deleteGoogleDriveFileLinkMutationVariables;
};



/*
mutation deleteGoogleDriveFileLinkMutation(
  $input: DeleteGoogleDriveFileLinkInput!
) {
  deleteGoogleDriveFileLink(input: $input) {
    deletedGoogleDriveFileId
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteGoogleDriveFileLinkInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteGoogleDriveFileLinkPayload",
    "kind": "LinkedField",
    "name": "deleteGoogleDriveFileLink",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedGoogleDriveFileId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deleteGoogleDriveFileLinkMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "deleteGoogleDriveFileLinkMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "deleteGoogleDriveFileLinkMutation",
    "operationKind": "mutation",
    "text": "mutation deleteGoogleDriveFileLinkMutation(\n  $input: DeleteGoogleDriveFileLinkInput!\n) {\n  deleteGoogleDriveFileLink(input: $input) {\n    deletedGoogleDriveFileId\n  }\n}\n"
  }
};
})();
(node as any).hash = '2d63f3d26699b2be553ce3ff1b502746';
export default node;
